import React from "react";
import "./TvSkelleton.css";

export default function TvSkelleton() {
  const skeletonItems = Array(12).fill(0);

  return (
    <div className="tv-skeleton-page">
      {/* --- LOGO --- */}
      <div className="tv-skeleton-logo"></div>

      {/* --- TITLE --- */}
      <div className="skeleton-title shimmer"></div>

      {/* --- DISCOUNT NOTE --- */}
      <div className="skeleton-note shimmer"></div>

      {/* --- GRID --- */}
      <div className="skeleton-grid">
        {skeletonItems.map((_, i) => (
          <div key={i} className="skeleton-item">
            <div className="skeleton-img shimmer"></div>
            <div className="skeleton-info">
              <div className="skeleton-line short shimmer"></div>
              <div className="skeleton-line shimmer"></div>
              <div className="skeleton-price shimmer"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
